import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom"
import { api_call, console_log } from './helpers/untils';

const TeslaApiPage = () => {
  const history = useHistory();
  const location = useLocation()

  const params = new URLSearchParams(location.search)
  const code = params.get("code")
  console.log(`code:::::`, code)

  useEffect(() => {
    callGetThirdPartyAccessTokenApi()
  }, [code]);

  const callGetThirdPartyAccessTokenApi = async () => {
    if (code) {
      const response = await api_call(`/api/tesla/login-callback?code=${code}`);
      if (response.ok) {
        const res = await response.json()
        console_log("tesla login callback:::", res)
        const tokens = res.tokens;
        if (tokens) {
          history.push('/tesla-device')
          return true
        } else {
          alert("Invalid request")
        }
      }
    }
  }

  return (
    <div style={{ display: 'none' }}>
      Tesla API Page
    </div>
  );
};

export default TeslaApiPage;
